import React, { memo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { BaseItem, TableProps } from '@lib/components/Table/types';
import { getColumnsCount } from '@lib/components/Table/utils';
import styles from './TableFooter.module.scss';

type Props = {
  hasActionsColumn: boolean;
};

function TableFooter<T extends BaseItem>(props: Props & TableProps<T>) {
  const { Footer, columns, data, hasActionsColumn } = props;
  const hasColumnsFooter = columns.some((column) => column.Footer);
  const hasTableFooter = !!Footer;

  if (!hasColumnsFooter && !hasTableFooter) return null;

  const renderColumnsFooter = () => (
    <tr>
      {columns.map((column) => {
        const ColumnFooter = column.Footer || null;
        return (
          <td key={column?.id || uuidv4()}>
            {ColumnFooter && <ColumnFooter data={data} />}
          </td>
        );
      })}
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      {hasActionsColumn && <td> </td>}
    </tr>
  );

  const renderTableFooter = () => (
    <tr>
      <td colSpan={getColumnsCount(props)}>{hasTableFooter && <Footer />}</td>
    </tr>
  );

  return (
    <tfoot className={styles.footer}>
      {hasColumnsFooter && renderColumnsFooter()}
      {hasTableFooter && renderTableFooter()}
    </tfoot>
  );
}

export default memo(TableFooter) as <T extends BaseItem>(
  props: Props & TableProps<T>,
) => React.ReactElement;
